import React, { ComponentProps } from "react";
import { Platform, StyleSheet, Text, View, ViewProps } from "react-native";
import AppTheme from "../../utils/Theme";
import NavBarButton from "../NavBar/NavBarButton";
import { IcClose } from "../../utils/Icons";
import PrintButton from "../../../specific/views/PrintButton";

interface DocumentContainerProps extends ViewProps {
    documentTitle?: string;
    mainColor?: string;
    onDocumentCloseRequest: () => void;
    htmlToPrint?: string;
    pdfToPrint?: string;
    isDraft?: boolean;
}

const DocumentContainer = (props: DocumentContainerProps) => {

    const { children, mainColor, isDraft = false, htmlToPrint, pdfToPrint, documentTitle = "", onDocumentCloseRequest } = props;
    const appTheme: AppTheme = new AppTheme();

    const viewWidth: number = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullScreenWidth();

    const renderDraftIndicator = (): React.JSX.Element => {
        if (isDraft === true) {
            return <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <Text style={{ color: "#FFFFFF", fontFamily: appTheme.liliFont, fontSize: 16 }}>Brouillon</Text>
            </View>;
        }
        return <View />;
    }

    const renderPrintButton = (): React.JSX.Element | null => {
        if (htmlToPrint !== undefined) {
            return <PrintButton color={mainColor} remotePdfToShare={pdfToPrint} htmlToPrint={htmlToPrint} title={documentTitle} />
        }
        return null;
    }

    return <View style={[styles.container, { width: viewWidth, height: appTheme.getFullScreenHeight(), borderRadius: Platform.OS === "web" ? appTheme.pixelPerfect(20) : 0  }]}>
        <View style={[styles.navbar, { backgroundColor: mainColor, height: appTheme.topInsets + appTheme.pixelPerfect(60), width: viewWidth, paddingTop: appTheme.topInsets, paddingHorizontal: appTheme.pixelPerfect(5) }]}>
            <NavBarButton
                action={onDocumentCloseRequest}
                icon={IcClose} />
            {renderDraftIndicator()}
            {renderPrintButton()}
        </View>
        {children}
    </View>

}

export default DocumentContainer;

const styles = StyleSheet.create({
    container: {
        backgroundColor: "#FFFFFF",
        alignItems: "center",
        overflow: "hidden"
    },
    navbar: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    }
});